import { type FormEvent, type ReactNode, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import * as authApi from '../api/auth';
import { TelaAuth } from '../components/TelaAuth';
import { BlocoAviso, Botao, Campo } from '../components/ui';
import { useAuth } from '../lib/auth';
import { ApiError } from '../lib/http';
import { MSG_ERRO_REDE, mensagemDeErro } from '../lib/erros';

export function PrimeiroAcessoPagina(): ReactNode {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const { registrarSessao } = useAuth();

  const [senha, setSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (!token) {
    return (
      <TelaAuth>
        <BlocoAviso tom="aviso">Este link expirou. Peça um novo ao administrador.</BlocoAviso>
      </TelaAuth>
    );
  }

  const aoEnviar = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setErro(null);
    if (senha.length < 8) {
      setErro('A senha precisa de pelo menos 8 caracteres.');
      return;
    }
    if (senha !== confirma) {
      setErro('As senhas não são iguais.');
      return;
    }
    setEnviando(true);
    try {
      const dados = await authApi.primeiroAcesso(token, senha);
      registrarSessao({
        accessToken: dados.accessToken,
        refreshToken: dados.refreshToken,
        usuario: authApi.usuarioDeResposta(dados),
      });
      navigate('/', { replace: true });
    } catch (err) {
      if (err instanceof ApiError) {
        setErro(
          err.ehRede
            ? MSG_ERRO_REDE
            : err.codigo === 'nao_autenticado'
              ? 'Este link expirou ou já foi usado. Peça um novo ao administrador.'
              : mensagemDeErro(err.codigo),
        );
      } else {
        setErro(MSG_ERRO_REDE);
      }
    } finally {
      setEnviando(false);
    }
  };

  return (
    <TelaAuth>
      <form onSubmit={(e) => void aoEnviar(e)} className="flex flex-col gap-4" noValidate>
        <p className="text-corpo text-tinta-2">Criar senha</p>
        {erro && <BlocoAviso tom="erro">{erro}</BlocoAviso>}
        <Campo
          rotulo="Nova senha"
          type="password"
          autoComplete="new-password"
          autoFocus
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        <Campo
          rotulo="Confirmar senha"
          type="password"
          autoComplete="new-password"
          value={confirma}
          onChange={(e) => setConfirma(e.target.value)}
        />
        <Botao type="submit" carregando={enviando}>
          {enviando ? 'Salvando…' : 'Criar senha'}
        </Botao>
        <Link to="/login" className="text-nota text-acento-texto underline">
          Voltar para o login
        </Link>
      </form>
    </TelaAuth>
  );
}
